/**
 * Resolve probe target URLs (mirrors backend probeUrlUtils.js).
 */

export function normalizeEndpointPath(path) {
  let p = String(path || "").trim();
  if (/^\/https?:\/\//i.test(p)) {
    p = p.slice(1);
  }
  return p;
}

export function resolveProbeUrl(baseUrl, path) {
  const p = normalizeEndpointPath(path);
  if (!p) {
    return String(baseUrl || "").replace(/\/+$/, "");
  }
  if (/^https?:\/\//i.test(p)) {
    return p.replace(/\/+$/, "") || p;
  }
  const base = String(baseUrl || "").replace(/\/+$/, "");
  return p.startsWith("/") ? `${base}${p}` : `${base}/${p}`;
}

export function pathLooksLikeFullUrl(path) {
  return /^https?:\/\//i.test(normalizeEndpointPath(path));
}

export function pathHostDiffersFromBase(baseUrl, path) {
  const p = normalizeEndpointPath(path);
  if (!/^https?:\/\//i.test(p)) return false;
  try {
    const baseHost = new URL(String(baseUrl || "").trim()).host.toLowerCase();
    const pathHost = new URL(p).host.toLowerCase();
    return baseHost !== pathHost;
  } catch {
    return false;
  }
}
